import React, { useState } from "react";
import PropTypes from "prop-types";
// ui

// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
// components
import ErrorCapture from "./ErrorCapture";
import ConfirmModalHoc from "./ConfirmModalHoc";
// utils

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

//
const TemplateAuth = ({ children }) => {
  // style
  const classes = useStyles();
  // props

  // local state

  return (
    <>
      <ErrorCapture>
        <ConfirmModalHoc />
        {children}
      </ErrorCapture>
    </>
  );
};

TemplateAuth.propTypes = {
  children: PropTypes.node,
};

TemplateAuth.defaultProps = {
  children: null,
};

export default TemplateAuth;
